import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class FordCrossingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.FORD_CROSSING;
}

export default FordCrossingTileEntity;
